<template>
	<div id="master-activity-list">
		<div class="sticky-table-header">
			<vx-card style="overflow-x: auto;">
				<vs-row>
					<vs-col class="search-bar" vs-type="flex" vs-justify="right" vs-align="center">
						<vs-input icon-no-border icon="icon-search" icon-pack="feather" class="w-full input-rounded-full" placeholder="Cari User" v-model="searchText"/>
							<vs-tooltip text="Tambah">
								<vs-button radius size="large" type="border" color="#5d9fc6" icon="person_add" class="ml-3" @click="create()"></vs-button>
							</vs-tooltip>
							<vs-tooltip text="Edit" v-if="btnEdit === true">
								<vs-button radius size="large" type="border" color="warning" icon="edit" class="ml-3" @click="edit()"></vs-button>
							</vs-tooltip>
							<vs-tooltip text="Reset Password" v-if="btnReset === true">
								<vs-button radius size="large" type="border" color="danger" icon="replay" class="ml-3" @click="rst()"></vs-button>
							</vs-tooltip>							
							<vs-tooltip text="Hapus" v-if="btnDel === true">
								<vs-button radius size="large" type="border" color="danger" icon="delete" class="ml-3" @click="rem()"></vs-button>
							</vs-tooltip>
						</vs-col>
					</vs-row>
				</vx-card>
		</div>

		<vx-card title="Daftar User" class="sticky-table-content mt-sticky">
			<vs-table stripe max-items="10" class="mb-base" :data="listData" style="text-align:left;" @selected="handleSelected">
				<template slot="thead">
					<vs-th>Username</vs-th>
					<vs-th>Nama</vs-th>
					<vs-th>Role</vs-th>
				</template>
				<template slot-scope="{data}">
					<vs-tr :state="tr.id==idSelected?'primary':null" :data="tr" :key="indextr" v-for="(tr, indextr) in data">
						<vs-td>
							{{data[indextr].username}}
						</vs-td>
						<vs-td>
							{{data[indextr].name}}
						</vs-td>
						<vs-td>
							{{data[indextr].roles.name}}
						</vs-td>
					</vs-tr>
				</template>
			</vs-table>
			<vs-pagination class="pagination pagination-warning" :total="totalItem" v-model="page" @input="find"></vs-pagination>
		</vx-card>
		
		<vs-prompt class="w50"
        	title="Konfirmasi Hapus User"
	        @accept="acceptDelete"
    	    accept-text="Hapus"
        	cancel-text="Batal"
	        :active.sync="activeDelete">
         	<div>
           			<div class="vx-col w-full mt-2 mb-2">
						<vs-row>
							<vs-col vs-w="12">
								<vs-input name="nameUser" disabled label="Nama User" class="w-full" v-model="nameUser"/>
							</vs-col>
						</vs-row>
		           	</div>
	         </div>
       	</vs-prompt>


		<vs-prompt class="w50"
        	title="Reset Password"
	        @accept="acceptReset"
    	    accept-text="Reset"
        	cancel-text="Batal"
	        :active.sync="activeReset">
         	<div>
           		<div class="vx-col w-full mt-2 mb-2">
            		<vs-row>
              			<vs-col vs-w="12">
                			<vs-input name="nameUser" disabled label="Nama User" class="w-full" v-model="nameUser"/>
              			</vs-col>
            		</vs-row>
            		<vs-row>
              			<vs-col vs-w="12">
							<vs-input type="password" name="npass" label="Password Baru" class="w-full" v-model="npass"/>
              			</vs-col>
            		</vs-row>					
		        </div>
	         </div>
       	</vs-prompt>

	</div>
</template>

<script>
import ref from "@/api/ref.js";
import formsearch from "@/api/form-search.js";
import user from "@/api/user.js";
import tool from "@/tool/form_tool.js";
import { VueContext } from "vue-context";


export default {
	components: {
		VueContext
	},
	data() {
		return {
			idSelected: null,
			listData: {maxPage:0, data: []},
			loading: true,
			perPage: 50,
			page: 1,
			totalItem: 1,
			activeDelete: false,
			btnEdit: false,
			btnDel: false,
			btnReset: false,
			model: {},
			nameUser:'',
			npass: '',
			activeReset: false,
			schema: {
				fields: []
			},
			formOptions: {
				validateAfterLoad: true,
				validateAfterChanged: true,
				validateAsync: true
			},
            searchText: ''
		};
	},
	methods: {
		listen(newVal, schema) {
			if (schema == "provinceId") {
				this.getCityByProvince(false);
				return;
			}
		},
		async find(pg) {
			this.model["perPage"] = this.perPage;
			this.model["page"] = pg;
			this.listData= {maxPage:0, data: []};
			const frm = await user.userList(this.model);
			if (frm.data.status != false) {
				this.listData = frm.data.data;
				this.totalItem = frm.data.maxPage;
			}
		},
		async firstLoad() {
			//const frms = await formsearch.getFormUser();
			//this.schema.fields = frms.data.data[0].fields;
			//this.model = frms.data.data[0].model;
			//await this.getRole();
			this.find(1);
		},
		async getRole() {
			const prov = await ref.getRole();
			tool.copyValuesToDropDown(
				this.schema.fields,
				"roleId",
				prov.data.data
			);
		},
		handleSelected(tr) {
			this.idSelected = tr.id;
			this.btnEdit = true;
			this.btnDel = true;
			this.btnReset = true;
			this.listData.forEach(el => {
				if (this.idSelected == el.id) {
					this.nameUser = el.name;
				}
			});
		},
		create() {
			this.$router.push('/user/create');
		},
		edit() {
			this.$router.push({name: 'user-edit', params: {id: this.idSelected}});
		},
		rem() {
			this.activeDelete = true;
		},
		rst() {
			this.npass = '';
			this.activeReset = true;
		},
		acceptReset() {
			this.activeReset = false;
			this.onConfirmReset();
		},
		onConfirmReset() {
			this.$vs.dialog({
				type: 'confirm',
				color: 'warning',
				title: `Konfirmasi`,
				text: 'Anda yakin untuk reset password user ini ?',
				acceptText: 'Ya',
				cancelText: 'Tidak',
				accept: this.resetData
			})
		},	
		resetData() {
			this.loading = true;
			let config = {
				headers: {
					"content-type": "application/json"
				}
			};
			
			let m = {id : this.idSelected, password: this.npass};

			user.resetPasswordUser(m, config)
				.then(res => {
					if (res.data.status) {
						this.$vs.notify({
							title: "Info",
							time: 3000,
							text: "Data telah berhasil di submit",
							color: "success",
							position: "top-right"
						});
						this.$router.push("/user/list");
					} else {
						this.$vs.notify({
							title: "Terjadi Kesalahan",
							time: 3000,
							text: res.data.message,
							color: "danger",
							position: "top-right"
						});
					}
				})
				.catch(error => {
					if (error.response) {
						this.$vs.notify({
							title: "An Error Occured",
							time: 3000,
							text: error.response.data.message,
							color: "danger",
							position: "top-right"
						});
					}
				});			
		},		
		acceptDelete() {
			this.acceptDelete = false;
			this.onConfirmDelete();
		},
		onConfirmDelete() {
			this.$vs.dialog({
				type: 'confirm',
				color: 'warning',
				title: `Konfirmasi`,
				text: 'Anda yakin untuk menghapus data ini ?',
				acceptText: 'Ya',
				cancelText: 'Tidak',
				accept: this.deleteData
			})
		},	
		deleteData() {
			this.loading = true;
			let config = {
				headers: {
					"content-type": "application/json"
				}
			};
			
			let m = {id : this.idSelected};

			user.deleteUser(m, config)
				.then(res => {
					if (res.data.status) {
						this.$vs.notify({
							title: "Info",
							time: 3000,
							text: "Data telah berhasil di submit",
							color: "success",
							position: "top-right"
						});
						this.$router.push("/user/list");
					} else {
						this.$vs.notify({
							title: "Terjadi Kesalahan",
							time: 3000,
							text: res.data.message,
							color: "danger",
							position: "top-right"
						});
					}
				})
				.catch(error => {
					if (error.response) {
						this.$vs.notify({
							title: "An Error Occured",
							time: 3000,
							text: error.response.data.message,
							color: "danger",
							position: "top-right"
						});
					}
				});			
		},			
	},
	computed: {},
	created() {
		this.firstLoad();
	},
	watch: {
		page: function(newValue, oldValue) {
			// here you can do whatever you want
			this.find(newValue);
		}
	}
};
</script>
